var map = {
	"./arrow-back.svg": 804,
	"./arrow-icon.svg": 1878,
	"./arrow-next.svg": 7438,
	"./arrow-prev.svg": 9922,
	"./arrow-search.svg": 7025,
	"./arrow-top-right.svg": 4007,
	"./bag.svg": 69,
	"./burger.svg": 7070,
	"./carbon-footprint.svg": 156,
	"./check.svg": 2976,
	"./close.svg": 4695,
	"./disabled.svg": 2149,
	"./disc.svg": 1674,
	"./discontinued.svg": 9540,
	"./edit-pencil.svg": 4501,
	"./email-white.svg": 1279,
	"./email.svg": 6079,
	"./exclamation.svg": 4120,
	"./favorite-heart-empty-pdp-max-lite.svg": 9457,
	"./favorite-heart-empty.svg": 1050,
	"./favorite-heart-full-pdp-max-lite.svg": 1607,
	"./favorite-heart-full.svg": 5836,
	"./favorite-heart-outlined-pdp-max-lite.svg": 6560,
	"./favorite-heart-outlined.svg": 6473,
	"./filter.svg": 7339,
	"./ico-arrow-up.svg": 2006,
	"./ico-facebook.svg": 6765,
	"./ico-instagram.svg": 6935,
	"./ico-mail.svg": 7468,
	"./ico-pinterest.svg": 2125,
	"./ico-tumblr.svg": 7995,
	"./ico-twitter.svg": 8234,
	"./ico-youtube.svg": 7392,
	"./icon-account.svg": 4480,
	"./icon-bell.svg": 1980,
	"./icon-burger-black.svg": 6926,
	"./icon-burger-close-black.svg": 8949,
	"./icon-chevron.svg": 8596,
	"./icon-earth.svg": 6729,
	"./icon-edit-black.svg": 4521,
	"./icon-edit-white.svg": 8623,
	"./icon-email.svg": 4801,
	"./icon-favorite-black-in-circle-white.svg": 1784,
	"./icon-favorite-black-on-transparent-background.svg": 5897,
	"./icon-favorite-thin.svg": 5797,
	"./icon-favorite-white.svg": 5787,
	"./icon-header-search.svg": 4017,
	"./icon-remove-black.svg": 9797,
	"./icon-remove-white.svg": 2939,
	"./icon-switch.svg": 2679,
	"./icon-tick.svg": 5384,
	"./loreal-paris-logo.svg": 440,
	"./media-pause-icon.svg": 6108,
	"./media-play-icon.svg": 7948,
	"./my-account.svg": 9781,
	"./open-new-window.svg": 5193,
	"./pause.svg": 8245,
	"./play-white-border.svg": 9714,
	"./play.svg": 3871,
	"./plus.svg": 9913,
	"./schedule.svg": 5314,
	"./search.svg": 1717,
	"./sound-available.svg": 4452,
	"./sound-muted.svg": 3284,
	"./sound-not-available.svg": 7124,
	"./tick.svg": 4325,
	"./trash-closed.svg": 4370,
	"./trash-opened.svg": 6321,
	"./water-footprint.svg": 9944,
	"./wow-badge-round.svg": 6563,
	"./wow-quotes.svg": 2656
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4191;